module.exports = __webpack_public_path__ + "img/wx.8b306754.jpg";